
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/experimental-api/configure-the-sx-prop",
      function () {
        return require("private-next-pages/system/experimental-api/configure-the-sx-prop.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/experimental-api/configure-the-sx-prop"])
      });
    }
  